module.exports = __webpack_public_path__ + "img/SEJ_Eventos_fecha.9fb984c5.svg";